import React, { memo } from 'react';
import { message, Row, Col } from 'antd';
import SurveysService from '../SurveysService';

import styles from './report.module.css';
import StatisticCard from './StatisticCard';
import { ReportProps } from './Report';

interface ReportStatisticsProps extends ReportProps {}

interface ReportStatisticsState {
    loading: boolean;
    stats: any;
}

const toTime = (timeInSeconds: number) => {
    const secs = Math.trunc(timeInSeconds % 60);
    const mins = Math.trunc(timeInSeconds / 60);
    return `${mins} min ${secs > 0 ? secs + ' seg' : ''}`.trim();
};

class ReportStatistics extends React.Component<
    ReportStatisticsProps,
    ReportStatisticsState
> {
    state: ReportStatisticsState = {
        loading: true,
        stats: {},
    };

    queryData = async () => {
        const { client, surveyId, filters } = this.props;

        this.setState({ loading: true });

        try {
            let stats = await SurveysService.getSurveyStatistics(
                client,
                surveyId,
                filters
            );
            this.setState({ stats, loading: false });
        } catch (err) {
            console.error(err);
            message.error((err as any).message);
        }
    };

    async componentDidMount() {
        this.setState({
            stats: {
                total: 0,
                finished: 0,
                average_seconds: 0,
                historic: [
                    {
                        day: '2020-04-07',
                        total: 0,
                    },
                    {
                        day: '2020-04-08',
                        total: 0,
                    },
                    {
                        day: '2020-04-09',
                        total: 0,
                    },
                    {
                        day: '2020-04-10',
                        total: 0,
                    },
                    {
                        day: '2020-04-11',
                        total: 0,
                    },
                    {
                        day: '2020-04-12',
                        total: 0,
                    },
                    {
                        day: '2020-04-13',
                        total: 0,
                    },
                ],
                average_time_by_question: [
                    {
                        question_number: 1,
                        average_seconds: 0,
                    },
                    {
                        question_number: 2,
                        average_seconds: 0,
                    },
                    {
                        question_number: 3,
                        average_seconds: 0,
                    },
                    {
                        question_number: 4,
                        average_seconds: 0,
                    },
                    {
                        question_number: 5,
                        average_seconds: 0,
                    },
                    {
                        question_number: 6,
                        average_seconds: 0,
                    },
                    {
                        question_number: 7,
                        average_seconds: 0,
                    },
                    {
                        question_number: 8,
                        average_seconds: 0,
                    },
                    {
                        question_number: 9,
                        average_seconds: 0,
                    },
                ],
            },
        });

        if (this.props.surveyId) await this.queryData();
    }

    async componentDidUpdate(prevProps: ReportStatisticsProps) {
        if (
            this.props.surveyId &&
            (JSON.stringify(this.props.filters) !==
                JSON.stringify(prevProps.filters) ||
                prevProps.surveyId !== this.props.surveyId)
        ) {
            await this.queryData();
        }
    }

    render() {
        const { stats, loading } = this.state;

        return (
            <div className={styles.statistics}>
                <Row gutter={16}>
                    <Col
                        xs={24}
                        sm={12}
                        md={8}
                        style={{ marginBottom: '16px' }}
                    >
                        <StatisticCard
                            title="Número de aperturas"
                            type="Line"
                            description="Número de veces que se abrió la evaluación e histórico de aperturas de los últimos 7 días"
                            value={stats.total}
                            loading={loading}
                            historicData={(stats.historic || []).map(
                                (h: any) => ({ id: h.day, value: h.total })
                            )}
                        />
                    </Col>
                    <Col
                        xs={24}
                        sm={12}
                        md={8}
                        style={{ marginBottom: '16px' }}
                    >
                        <StatisticCard
                            title="% Finalización"
                            type="Percent"
                            description="El porcentaje de finalización de la encuesta se refiere al número de evaluaciones diligenciadas en su totalidad sobre el número de evaluaciones iniciadas"
                            loading={loading}
                            value={stats.finished / (stats.total || 1)}
                            additionalData={{
                                count: stats.finished,
                                total: stats.total,
                            }}
                        />
                    </Col>
                    <Col
                        xs={24}
                        sm={12}
                        md={8}
                        style={{ marginBottom: '16px' }}
                    >
                        <StatisticCard
                            title="Tiempo promedio"
                            type="Bar"
                            description="Tiempo promedio de respuesta de la evaluación y tiempos promedio de cada pregunta."
                            loading={loading}
                            value={toTime(stats.average_seconds)}
                            historicData={(
                                stats.average_time_by_question || []
                            ).map((a: any) => ({
                                id: a.question_title,
                                value: a.average_seconds,
                                valueAsText:
                                    a.average_seconds.toFixed(2) + ' seg',
                            }))}
                        />
                    </Col>
                </Row>
            </div>
        );
    }
}

export default memo(ReportStatistics);
